// PlayPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { breadcrumbLd } from '../components/Seo';
import ShogiGame from '../components/ShogiGame';
import { useLang } from '../i18n';
import { SITE_URL } from '../config/links';

const C = {
  tr: {
    title: 'Şogi Oyna — Bilgisayara Karşı Ücretsiz Japon Satrancı',
    h1: 'Şogi Oyna',
    seoDesc: 'Tarayıcıda ücretsiz şogi oyna: Kolay, Orta, Zor ve Usta seviyelerinde bilgisayara karşı ya da aynı cihazda arkadaşınla. Kayıt gerekmez.',
    lead: 'Zorluğu seç, tarafını belirle ve oyna. Giriş yaparsan kazandığın oyunlar liderlik tablosuna puan olarak yazılır.',
    aboutTitle: 'Zorluk seviyeleri',
    levels: [
      ['Kolay', 'Kuralları yeni öğrenenler için. Bilgisayar sık sık taş kaybeder; ilk galibiyetini burada al.'],
      ['Orta', 'İki hamle ileriyi düşünür, bedavaya taş vermez. Temel taktikleri denemek için ideal.'],
      ['Zor', 'Taş alışverişlerini sonuna kadar hesaplar ve şah güvenliğini gözetir.'],
      ['Usta', 'Daha uzun ve derin düşünür. Kale kurmadan ve planlı oynamadan yenmek zor.'],
    ],
    pointsNote: 'Liderlik puanı: galibiyet başına Kolay 1, Orta 2, Zor 3, Usta 4 puan. Geri alma kullanılan oyunlar puana sayılmaz.',
    tips: 'Kurallarda emin değil misin? Önce',
    tipsLink: 'Şogi nasıl oynanır',
    tipsEnd: 'sayfasına göz at.',
  },
  en: {
    title: 'Play Shogi Online vs Computer — Free Japanese Chess',
    h1: 'Play Shogi',
    seoDesc: 'Play shogi free in your browser: against the computer on Easy, Medium, Hard or Expert, or with a friend on the same device. No sign-up required.',
    lead: 'Pick a difficulty, choose your side and play. Sign in and your wins earn leaderboard points.',
    aboutTitle: 'Difficulty levels',
    levels: [
      ['Easy', 'For players who are just learning the rules. The computer often drops material — get your first win here.'],
      ['Medium', 'Looks two moves ahead and does not give pieces away. Ideal for practising basic tactics.'],
      ['Hard', 'Calculates exchanges to the end and keeps its king safe.'],
      ['Expert', 'Thinks longer and deeper. Hard to beat without a castle and a plan.'],
    ],
    pointsNote: 'Leaderboard points per win: Easy 1, Medium 2, Hard 3, Expert 4. Games where undo was used do not count.',
    tips: 'Not sure about the rules? Read',
    tipsLink: 'how to play shogi',
    tipsEnd: 'first.',
  },
};

export default function PlayPage() {
  const { lang, to, t } = useLang();
  const c = C[lang];

  const ld = [
    {
      '@context': 'https://schema.org',
      '@type': 'VideoGame',
      name: c.h1,
      url: SITE_URL + to('play'),
      inLanguage: lang,
      genre: ['Board game', 'Strategy'],
      gamePlatform: 'Web browser',
      playMode: ['SinglePlayer', 'MultiPlayer'],
      applicationCategory: 'Game',
      offers: { '@type': 'Offer', price: '0', priceCurrency: 'TRY' },
    },
    breadcrumbLd([{ name: t('brand'), path: to('home') }, { name: c.h1, path: to('play') }]),
  ];

  return (
    <>
      <Seo title={c.title} description={c.seoDesc} jsonLd={ld} />
      <div className="container py-3 py-md-4">
        <h1 className="mb-1" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.6rem)' }}>{c.h1}</h1>
        <p className="text-muted mb-3">{c.lead}</p>
        <ShogiGame />

        <section className="section pb-0">
          <h2 className="section-title mb-3" style={{ '--c': 'var(--c-play)' }}>{c.aboutTitle}</h2>
          <div className="row g-3">
            {c.levels.map(([name, desc], i) => (
              <div className="col-12 col-sm-6 col-lg-3" key={name}>
                <div className="panel h-100">
                  <span className={`tag ${['easy', 'medium', 'hard', 'expert'][i]} mb-2 d-inline-block`}>{name}</span>
                  <p className="small mb-0">{desc}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="small text-muted mt-3 mb-1">{c.pointsNote}</p>
          <p className="small text-muted">
            {c.tips} <Link to={to('howto')}>{c.tipsLink}</Link> {c.tipsEnd}
          </p>
        </section>
      </div>
    </>
  );
}
